/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IAai20Visitor } from '../v2/visitors/IAai20Visitor';
import { JsonCompat } from '../../compat/JsonCompat';
import { ExtensibleNode } from '../../core/models/ExtensibleNode';
import { IReferenceNode } from '../../core/models/IReferenceNode';
import { Node } from '../../core/models/Node';
import { INamed } from '../../core/models/common/INamed';
import { IVisitor } from '../../core/visitors/IVisitor';
import { AaiOperation } from './AaiOperation';
import { AaiParameter } from './AaiParameter';
import { AaiChannelBindings } from './AaiChannelBindings';
import { Document } from '../../core/models/Document';

/**
 * @author Jakub Senko <jsenko@redhat.com>
 * @param {Node} parent
 * @param {string} name
 * @class
 * @extends ExtensibleNode
 */
export abstract class AaiChannelItem extends ExtensibleNode implements IReferenceNode, INamed {
    public _name : string;

    public $ref : string;

    public description : string;

    public subscribe : AaiOperation;

    public publish : AaiOperation;

    public parameters : any;

    public bindings : AaiChannelBindings;

    public constructor(parent? : any, name? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            {
                let __args = arguments;
                super();
                if(this._name===undefined) this._name = null;
                if(this.$ref===undefined) this.$ref = null;
                if(this.description===undefined) this.description = null;
                if(this.subscribe===undefined) this.subscribe = null;
                if(this.publish===undefined) this.publish = null;
                if(this.parameters===undefined) this.parameters = null;
                if(this.bindings===undefined) this.bindings = null;
                if(this._name===undefined) this._name = null;
                if(this.$ref===undefined) this.$ref = null;
                if(this.description===undefined) this.description = null;
                if(this.subscribe===undefined) this.subscribe = null;
                if(this.publish===undefined) this.publish = null;
                if(this.parameters===undefined) this.parameters = null;
                if(this.bindings===undefined) this.bindings = null;
                (() => {
                    if(parent != null) {
                        this._parent = parent;
                        this._ownerDocument = parent.ownerDocument();
                    }
                })();
            }
            (() => {
                this._name = name;
            })();
        } else if(((typeof parent === 'string') || parent === null) && name === undefined) {
            let __args = arguments;
            let name : any = __args[0];
            super();
            if(this._name===undefined) this._name = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.description===undefined) this.description = null;
            if(this.subscribe===undefined) this.subscribe = null;
            if(this.publish===undefined) this.publish = null;
            if(this.parameters===undefined) this.parameters = null;
            if(this.bindings===undefined) this.bindings = null;
            if(this._name===undefined) this._name = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.description===undefined) this.description = null;
            if(this.subscribe===undefined) this.subscribe = null;
            if(this.publish===undefined) this.publish = null;
            if(this.parameters===undefined) this.parameters = null;
            if(this.bindings===undefined) this.bindings = null;
            (() => {
                this._name = name;
            })();
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && name === undefined) {
            let __args = arguments;
            super();
            if(this._name===undefined) this._name = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.description===undefined) this.description = null;
            if(this.subscribe===undefined) this.subscribe = null;
            if(this.publish===undefined) this.publish = null;
            if(this.parameters===undefined) this.parameters = null;
            if(this.bindings===undefined) this.bindings = null;
            if(this._name===undefined) this._name = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.description===undefined) this.description = null;
            if(this.subscribe===undefined) this.subscribe = null;
            if(this.publish===undefined) this.publish = null;
            if(this.parameters===undefined) this.parameters = null;
            if(this.bindings===undefined) this.bindings = null;
            (() => {
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let v : IAai20Visitor = <IAai20Visitor><any>visitor;
        v.visitChannelItem(this);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }

    /**
     * Adds a parameter.
     * @param {string} paramName
     * @param {AaiParameter} param
     */
    public addParameter(paramName : string, param : AaiParameter) {
        if(this.parameters == null) {
            this.parameters = <any>({});
        }
        /* put */(this.parameters[paramName] = param);
    }

    public getParameterlist() : Array<AaiParameter> {
        return JsonCompat.mapToList<any>(this.parameters);
    }
}
AaiChannelItem["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiChannelItem";
AaiChannelItem["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];




